<template>
  <div>
    <default-dialog :loading="loading" fullscreen>
      <template slot="title">
        {{supplier.data.attributes.name}}
      </template>
      <template slot="content">
        <v-container>
          <v-expansion-panels v-if="!loading" popout v-model="panel" flat active-class="elevation-4 ma-3 pa-3">
            <v-expansion-panel style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-information</v-icon>
                  Informações básicas & Metas
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <card-loading-transparent v-if="saving" loadingText="Salvando"></card-loading-transparent>
                <v-form v-if="!saving" ref="form" :readonly="!editing_basic_infos">
                  <div class="d-flex">
                    <v-spacer></v-spacer>
                    <f-btn v-if="user_allowed && !editing_basic_infos" class="ml-2" @click="editing_basic_infos = true" edit></f-btn>
                    <f-btn v-if="editing_basic_infos" class="ml-2" @click="() => {editing_basic_infos = false; getData()}" cancel></f-btn>
                    <f-btn v-if="editing_basic_infos" class="ml-2" @click="startUpdateSupplier('info')" save></f-btn>
                  </div>
                  <v-row justify="space-around">
                    <v-col cols='12'>
                      <v-text-field 
                        v-model="supplier.data.attributes.name" 
                        label="Nome" 
                        :rules="required"
                        @input="checkName(supplier.data.attributes.name, all_brands)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols='12' sm='6' md='4'>
                      <v-text-field 
                        label="Contato (0800)"
                        v-model="supplier.data.attributes.contact_number" 
                      ></v-text-field>
                    </v-col>
                    <v-col cols='12' sm='6' md='4'>
                      <v-text-field 
                        v-model="supplier.data.attributes.set_goal"
                        number label="Meta atual"
                        :rules="required"
                      ></v-text-field>
                    </v-col>
                    <v-col cols='12' sm='6' md='4'>
                      <v-select 
                        label="Segmentos" item-text="name" item-value="id" 
                        :items="all_segments" v-model="supplier.data.attributes.segment_ids" 
                        :menu-props="{ top: false, offsetY: true }"
                        :rules="required"
                        multiple
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
  
            <v-expansion-panel style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-numeric</v-icon>
                  Códigos do Grupo Cimentão
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <card-loading-transparent v-if="saving" loadingText="Salvando"></card-loading-transparent>
                <div v-if="!saving">
                  <div class="d-flex">
                    <v-spacer></v-spacer>
                    <f-btn v-if="user_allowed && !editing_codes" class="ml-2" @click="edit_code = true" edit></f-btn>
                  </div>
                  <v-row>
                    <v-col cols='12' md="4" v-if="code.attributes.code != 0" v-for="(code, index) in supplier.data.attributes.codesA.data" :key="`code${index}`">
                      <v-text-field v-model="code.attributes.code" :label="code.attributes.company_name" readonly></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
  
            <v-expansion-panel style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-bank-check</v-icon>
                  Dados Bancários
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <card-loading-transparent v-if="saving" loadingText="Salvando"></card-loading-transparent>
                <div class="d-flex">
                  <v-spacer></v-spacer>
                  <f-btn edit v-if="user_allowed && !editing_bank_infos"  class="ml-2" small @click="editing_bank_infos = true"></f-btn>
                  <f-btn cancel v-if="editing_bank_infos" small class="ml-2" @click="() => {editing_bank_infos = false; getData()}" ></f-btn>
                  <f-btn save v-if="editing_bank_infos" small class="ml-2" @click="startUpdateSupplier('account')" ></f-btn>
                </div>
                <div v-if="!saving">
                  <BankAccountForm ref="form" :read_only="!editing_bank_infos" :account="supplier.data.attributes.bank_account.data.attributes"></BankAccountForm>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
  
            <v-expansion-panel style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold pb-1">
                <div>
                  <v-icon size="19" color="red">mdi-panorama-variant</v-icon>
                  Foto
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-btn
                  v-if="user_allowed && supplier.data.attributes.photo && typeof (supplier.data.attributes.photo) == 'object'"
                  rounded block 
                  color="success" 
                  class="font-weight-bold"
                  @click="updateDocuments()"
                >
                  <v-icon left style="font-size: 22px">fa-save</v-icon> Atualizar
                </v-btn>
                <template>
                  <div class="mt-1 mb-1">
                    <input type="file" accept="image/*" style="display: none" id="file" ref="file" @change="handleFile()">
                  </div>
                  <div class="d-flex justify-center pb-3">
                    <v-btn 
                      v-if="user_allowed"
                      rounded color="info" 
                      class="font-weight-bold" 
                      @click="$refs.file.click()"
                      disabled
                    >
                      <v-icon left style="font-size: 22px">fa-camera-retro</v-icon> 
                      {{ supplier.data.attributes.photo ? 'Alterar' : 'Adicionar' }} foto
                    </v-btn>
                  </div>
                  <template v-if="supplier.data.attributes.photo && typeof (supplier.data.attributes.photo) == 'string'">
                    <v-img v-if="supplier.data.attributes.photo" :src="supplier.data.attributes.photo" contain max-width="400"></v-img>
                  </template>
                  <template v-if="newAttachment[0] && newAttachment[0].data">
                    <v-img v-if="newAttachment[0].content_type.includes('ima')" :src="newAttachment[0].data" contain max-width="400"></v-img>
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{ newAttachment[0].file_name }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn text icon @click="removeFile()"> <v-icon small color="red">fa-trash-alt</v-icon> </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </template>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-package-variant-closed</v-icon>
                  Produtos
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <card-loading-transparent v-if="productsLoading" loadingText="Carregando produtos"></card-loading-transparent>
                <div v-if="!productsLoading">
                  <div class="d-flex justify-end mb-3">
                    <v-btn
                      :color="!register_product ? 'primary' : 'error'"
                      :outlined="register_product"
                      small
                      @click="register_product = !register_product"
                      class="mr-2"
                      >
                      <v-icon small left>{{ !register_product ? 'mdi-plus' : 'mdi-arrow-left' }}</v-icon>
                      {{ !register_product ? 'Cadastrar Produto' : 'Cancelar' }}
                    </v-btn>

                    <v-btn
                      v-if="!register_product"
                      :color="showOnlyActiveProducts ? 'primary' : 'grey'"
                      :outlined="!showOnlyActiveProducts"
                      small
                      @click="showOnlyActiveProducts = !showOnlyActiveProducts"
                      >
                      <v-icon small left>mdi-filter</v-icon>
                      {{ showOnlyActiveProducts ? 'Produtos Ativos' : 'Produtos Inativos' }}
                    </v-btn>
                  </div>
                  <v-data-table
                    v-if="!register_product"
                    :headers="productHeaders"
                    :items="products"
                    :search="productSearch"
                    class="mb-4"
                    mobile-breakpoint="1"
                  >
                    <template v-slot:top>
                      <v-text-field
                        v-model="productSearch"
                        append-icon="mdi-magnify"
                        label="Pesquise.."
                        single-line
                        hide-details
                        class="mx-3"
                      ></v-text-field>
                    </template>
                    <template v-slot:item.status_name="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" :color="item.status_name.includes('Act') ? 'success' : 'error'">
                            {{ item.status_name.includes('Act') ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                        </template>
                        <span>{{ item.status_name.includes('Act') ? 'Produto ativo' : 'Produto inativo' }}</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.status_update="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            color="primary"
                            v-on="on"
                            small
                            @click="updateProductStatus(item)"
                          >{{ item.status_id === 1 ? 'Desabilitar' : 'Habilitar' }}</v-btn>
                        </template>
                        <span>Habilitar/Desabilitar produto</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            color="primary"
                            v-on="on"
                            icon
                            @click="editProduct(item)"
                          ><v-icon>mdi-pencil</v-icon></v-btn>
                        </template>
                        <span>Editar produto</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:no-data>
                      <v-alert :value="true" type="warning" icon="mdi-alert" class="mt-3 black--text">
                        Nenhum produto a ser exibido.
                      </v-alert>
                    </template>
                  </v-data-table>

                  <v-divider class="my-4"></v-divider>
                  <h4 class="red--text font-weight-bold mb-3" v-if="register_product">Cadastrar produto</h4>
                  <register-product
                    v-if="supplier.data.attributes.name && register_product"
                    :brands="brandOptions"
                    :default-brand-id="Number($route.params.id)"
                    hide-brand-select
                    @created="getProducts"
                  ></register-product>
                </div>
                <dialog-loading v-if="productStatusSaving" loadingText="Atualizando status do produto"></dialog-loading>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>

        <v-dialog
          :value="edit_code" 
          scrollable persistent 
          :overlay="true" 
          max-width="500px"
          transition="dialog-transition" 
          :return-value.sync="supplier.data" 
          v-if="supplier != null"
        >
          <v-card v-if="!saving">
            <v-card-title>
              <span class="headline">Editando dados da {{ supplier.data.attributes.name }}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form">
                <v-col cols='12'>
                  <template v-for="(code, index) in supplier.brand_company_codes_attributes">
                  <v-row :key="`cod${index}`">
                    <v-col cols='8' sm='8' class="py-0">
                      <v-checkbox :label="code.company_name" v-model="code.active"></v-checkbox>
                    </v-col>
                    <v-col cols='4' sm='3' class="py-0">
                      <v-text-field label="Código" v-model="code.code" :disabled="!code.active" :rules="code.active ? required : []" ></v-text-field>
                    </v-col>
                    <v-col cols='12' hidden-sm-and-up class="py-0">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <f-btn cancel @click="edit_code = false"></f-btn>
              <f-btn save @click="startUpdateSupplier('code')"></f-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </template>
      <template slot="actions">
        <f-btn close @click="closeEditBrand" small></f-btn>
      </template>
    </default-dialog>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Api from '@/api/index';
import validations from "@/mixins/validations";

export default {
  name: 'EditBrand',
  mixins: [validations],
  components:{
    BankAccountForm: () => import("@/_backoffice/_registrations/components/shared/forms/BankAccountForm.vue"),
    RegisterProduct: () => import("@/_backoffice/_registrations/components/supplier/register/suppliers/RegisterProduct.vue"),
  },
  data() {
    return {
      panel: [],
      all_segments: [],
      supplier: {
        data:{ 
          attributes: {
            name:"",
            
          }
        }
      },
      newAttachment: ['', ''],
      check: true,
      edit_dialog: true,
      editing_basic_infos: false,
      editing_codes: false,
      editing_bank_infos: false,
      attachment_attributes: [{ type: 'null' }, { type: 'null' }],
      edit_code: false,
      all_codes: false,
      loading: true,
      saving: false,
      had_eddited_name: false,
      products: [],
      productsLoading: false,
      productStatusSaving: false,
      showOnlyActiveProducts: true,
      register_product: false,
      productSearch: null,
      productHeaders: [
        { text: 'Nome', value: 'name' },
        { text: 'Segmento', value: 'segment_name', align: 'center' },
        { text: 'Status', value: 'status_name', align: 'center' },
        { text: 'Atualizar Status', value: 'status_update', align: 'center' },
        { text: 'Ação', value: 'actions', align: 'center' },
      ],
    }
  },
  methods: {
    getData() {
      this.getAllSegments()
      this.getSupplier({ id: this.$route.params.id, type: 'brands' })
    },
    getSupplier(params) {
      this.loading = true
      Api.Supplier.show(params).then((r) => {
        this.supplier = r.data
        this.getProducts()
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    getProducts() {
      this.productsLoading = true
      Api.SupplierV2.index('products', {
        brand_id: this.$route.params.id,
        status_id: this.showOnlyActiveProducts ? 1 : 2,
        without_ppl: true,
      }).then(r => {
        this.products = r.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.productsLoading = false
      })
    },
    editProduct(item) {
      this.$router.push({
        name: 'EditBrandProduct',
        params: { id: this.$route.params.id, productId: item.id },
      })
    },
    updateProductStatus(item) {
      this.swallConfirmation({
        title: 'Deseja atualizar o status do produto?',
        icon: 'question',
      }).then(confirmed => {
        if (confirmed) {
          this.productStatusSaving = true
          const product = {
            id: item.id,
            status_id: item.status_id === 1 ? 2 : 1,
          }
          Api.Supplier.updateOnlyProduct(product).then((r) => {
            const idx = this.products.findIndex(el => el.id == r.data.data.attributes.id)
            if (idx !== -1) {
              this.products[idx].status_id = r.data.data.attributes.status_id
              this.products[idx].status_name = r.data.data.attributes.status_name
            }
            this.addNotification({ type: 'success', msg: 'Status do produto atualizado com sucesso.' })
          }).catch((err) => {
            this.addNotification({ type: 'error', msg: `Erro: ${err}` })
          }).finally(() => {
            this.productStatusSaving = false
          })
        }
      })
    },
    getAllSegments() {
      Api.Supplier.indexSegment().then(r => r.data).then(d => {
        this.all_segments = [...d]
      })
    },
    checkName(name, list) {
      var nameOK = true
      this.check = true
      list.forEach(el => {
        if (el.id != this.supplier.id) {
          if (el.attributes.name.toLowerCase() == name.toLowerCase()) {
            nameOK = false
          }
        }
      });
      if (!nameOK) {
        let msg = 'Nome já cadastrado'
        this.addNotification({type:'error', msg})
        this.check = false
      }
      if (!name) {
        let msg = 'Nome é necessário'
        this.addNotification({type:'error', msg})
        this.check = false
      }
    },
    startUpdateSupplier(kind) {
      let METHOD = ''
      let data = {}

      if(this.$refs.form.validate()){
        this.swallConfirmation({
          title: 'Deseja atualizar informações da marca?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            if (kind == 'info') {
              METHOD = 'updateBrandInfo'
              data = this.prepareBrandInfos()
              this.editing_basic_infos = false
            } else if (kind == 'code') {
              this.genCodes()
              METHOD = 'updateBrandCodes'
              data = this.prepareBrandCodes()
              this.edit_code = false
            } else if (kind == 'account') {
              METHOD = 'updateBrandAccount'
              data = this.prepareBankInfos()
              this.editing_bank_infos = false
            }
            this.saving = true
            Api.Supplier[METHOD](data).then((r) => {
              if(kind == 'info'){
                let brand_name = this.all_brands.find((el)=> el.id == data.id).attributes.name
                if(brand_name != r.data.data.attributes.name){
                  this.had_eddited_name = true
                }
              }
              this.supplier = r.data
              this.addNotification({type: 'success',  msg: `Atualizado com sucesso.`})
            }).catch(err => {
              console.log(err)
              this.addNotification({type: 'error',  msg: `Erro: ${err}`})
            }).finally(() => {
              this.saving = false
              this.getData()
            })
          }
        })
      }else{
        this.addNotification({type: 'error',  msg: `Preencha todos os campos corretamente.`})
      }
    },
    genCodes() {
      this.supplier.brand_company_codes_attributes.forEach(code => {
        if (code.code == 0 || !code.active) {
          code.status_id = 2
          code.hasOwnProperty('id') ? code.code = 0 : code.code = null
        }
        if (code.code != 0) {
          code.status_id = 1
        }
      });
    },
    prepareBankInfos() {
      let bank = this.supplier.data.attributes.bank_account.data.attributes
      let bank_account = {
        id: this.$route.params.id,
        account_attributes: {
          id: bank?.id ? bank.id : null,
          bank_id: bank.bank_id,
          current_account: bank.current_account,
          agency: bank.agency,
          digit: bank.digit,
          number: bank.number,
          account_digit: bank.account_digit,
          CPF: bank.CPF,
          CNPJ: bank.CNPJ,
          name: bank.name,
        }
      }
      return bank_account
    },
    prepareBrandInfos() {
      let data = this.supplier.data.attributes
      
      let brand_data = {
        id: this.$route.params.id,
        name: data.name,
        segment_ids: [...data.segment_ids],
        goals_attributes: [{
          id: data.set_goal_attributes?.id ? data.set_goal_attributes.id : null,
          status_id: 13, // title: "Set", // description: "Goal set",
          goal: data.set_goal,
          due_date: new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0),
        }],
        contact_attributes: {
          id: data.contact?.data?.attributes?.id ? data.contact.data.attributes.id : null,
          celphone: data.contact_number
        },
      }
      return brand_data
    },
    prepareBrandCodes(){
      let data = {
        id: this.$route.params.id,
        brand_company_codes_attributes: [...this.supplier.brand_company_codes_attributes]
      }
      return data
    },
    closeEditBrand(){
      this.$router.push({name: 'BrandsList', params: {get_list: this.had_eddited_name}})
    },
    
    ...mapActions({
      getCompanies: 'Company/index',
    })
  },
  computed: {
    brandOptions() {
      return [{
        id: Number(this.$route.params.id),
        name: this.supplier.data.attributes.name,
      }]
    },
    user_allowed() {
      return this.isManager() || this.isDirector() || this.isSalesExecutive()
    },
    ...mapState({
      profile: state => state.User.oneUser,
      all_banks: state => state.Bank.allBanks,
      all_brands: state => state.Supplier.all_brands,
      all_companies: state => state.Company.allCompanies,

    })
  },
  watch: {
    '$route.params'(nv) {
      if (nv.product_updated_id) {
        const idx = this.products.findIndex(el => el.id == nv.product_updated_id)
        if (idx !== -1) {
          this.products[idx].name = nv.name
          this.products[idx].segment_id = nv.segment_id
          this.products[idx].segment_name = nv.segment_name
        }
      }
    },
    showOnlyActiveProducts(nv, ov) {
      if (nv != ov) {
        this.getProducts()
      }
    },
    edit_code(nv, ov) {
      if (nv) {
        this.getCompanies()
        var all_codes = this.supplier.data.attributes.codesA
        this.supplier = {
          ...this.supplier,
          id: this.supplier.data.id,
          brand_company_codes_attributes: [],
        }
        if (all_codes != null) {
          all_codes.data.forEach((code, index) => {
            var { id, code, company_id, company_name, status_id } = code.attributes
            var active = status_id == 1 ? true : false
            var obj = {
              id: id,
              code: code,
              company_id: company_id,
              company_name: company_name,
              status_id: status_id,
              active: active
            }
            this.supplier.brand_company_codes_attributes.push(obj)
          });
        }
        this.all_codes = true
      } else {
        this.all_codes = false
      }
    },
    all_companies(nv, ov) {
      // console.log({nv});
      if (nv && this.all_codes) {
        var not_iterate = []
        var new_codes_arr = []
        var new_codes_obj = {}
        var exists = false

        this.all_companies.forEach((com, c_index) => {
          if (this.supplier.brand_company_codes_attributes[0] != null) {
            this.supplier.brand_company_codes_attributes.forEach((bcc, bcc_index) => {

              if (com.attributes.id == bcc.company_id && !not_iterate.includes(bcc_index)) {
                not_iterate.push(bcc_index)
                exists = true
                new_codes_obj = {}
              } else if (com.attributes.id != bcc.company_id && !exists) {
                new_codes_obj = {
                  company_id: com.attributes.id,
                  active: false,
                  code: null,
                  company_name: com.attributes.name,
                  status_id: 1
                }
              }
            });
            new_codes_obj.hasOwnProperty('active') ? new_codes_arr.push(new_codes_obj) : null
            exists = false
          } else {
            new_codes_obj = {
              company_id: com.attributes.id,
              active: false,
              code: null,
              company_name: com.attributes.name,
              status_id: 1
            }
            new_codes_arr.push(new_codes_obj)
          }
        });
      }
      new_codes_arr.forEach(n_obj => {
        this.supplier.brand_company_codes_attributes.push(n_obj)
      });
    },
  },
  mounted() {


    this.getData()

  },
}
</script>

<style scoped>h3 {
  -webkit-text-fill-color: red !important;
}

h4 {
  -webkit-text-fill-color: red !important;
}</style>
